<template>
<div>
  <div class="intro">
    <h1>工作經驗回顧</h1>
    <h1>ENOW Experience Rewind</h1>
  </div>
  <div class="survey" v-if="!finished">
    <p>請回想你過往曾經做過的所有工作，然後依以下分類，填寫有做過的工作種類。</p>
    <hr align="center">
    <div class="question" v-for="(q, index) in enow_q" :key="index">
      <p>{{ q.name }}</p>
      <div class="onoffswitch">
        <input type="checkbox" name="onoffswitch" class="onoffswitch-checkbox" v-model="q.value" :id="q.name">
        <label class="onoffswitch-label" :for="q.name">
            <span class="onoffswitch-inner"></span>
            <span class="onoffswitch-switch"></span>
        </label>
      </div>
    </div>
    <div class="submit">
      <vs-button color="success" type="relief" @click="submitForm">Submit 提交</vs-button>
    </div>
  </div>
  <div class="survey" v-if="finished">
    <p>答案已成功提交! 請留意螢幕上即時更新結果。</p>
  </div>
</div>
</template>

<script>
import { db } from '../main';
import wordcloud_dict from '../assets/wordcloud-dict.js'

export default {
  name: 'ENOWQ',
  data() {
    return {
      enow_q: [],
      finished: false
    }
  },
  methods: {
    submitForm: function() {
      var instance = this;
      this.$vs.loading({type:'radius'});

      console.log("SubmitForm");
      var rtDocRef = db.collection("enow-cloud").doc("LnLHuCUUzFihi4Ni80yn");
      db.runTransaction(function(transaction) {
        return transaction.get(rtDocRef).then(function(rtDoc) {
          if (!rtDoc.exists) {
            throw "Cloud Firestore Data Corrupted, Please check the database"
          }

          var updater = {};
          // console.log(instance.enow_q);
          for (var q in instance.enow_q) {
            // console.log(instance.enow_q[q]);
            if (instance.enow_q[q].value == false) continue;
            var key = q.toString();
            updater[instance.enow_q[q].index] = rtDoc.data()[q] + 1;
            console.log(updater);
          }
          updater['total'] = rtDoc.data()['total'] + 1;
          transaction.update(rtDocRef, updater);

          instance.finished = true;
          instance.$vs.loading.close()
        })
      })
    }
  },
  mounted() {
    for (var key in wordcloud_dict) {
      if (wordcloud_dict.hasOwnProperty(key)) {
      // console.log(wordcloud_dict[key]);
      // console.log({index: key, name: wordcloud_dict[key], value: false})
      this.enow_q.push({index: key, name: wordcloud_dict[key], value: false});
      }
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
ul {
  list-style-type: none;
  padding: 10px 0;
}

.results > ul {
  list-style-type: circle;
}

li {
  padding: 3px;
}

.intro {
  padding: 10px;
}

.intro p {
  padding: 3px;
}

.question {
  padding: 5px 10%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.survey p {
  padding: 3px;
}

.description {
  display: flex;
  padding: 3px;
}

.submit {
  padding: 20px 0;
  text-align: center;
}

hr {
  width: 30%;
  text-align: center; 
  margin: 8px auto;
}

@media screen and (min-width: 1024px) {
  .question {
    padding: 5px 30%;
  }
  hr {
    width: 50%;
  }
}

.onoffswitch {
    position: relative; width: 78px;
    -webkit-user-select:none; -moz-user-select:none; -ms-user-select: none;
}
.onoffswitch-checkbox {
    display: none;
}
.onoffswitch-label {
    display: block; overflow: hidden; cursor: pointer;
    border: 2px solid #E3E3E3; border-radius: 36px;
}
.onoffswitch-inner {
    display: block; width: 200%; margin-left: -100%;
    transition: margin 0.3s ease-in 0s;
}
.onoffswitch-inner:before, .onoffswitch-inner:after {
    display: block; float: left; width: 50%; height: 25px; padding: 0; line-height: 25px;
    font-size: 16px; color: white; font-family: Trebuchet, Arial, sans-serif; font-weight: bold;
    box-sizing: border-box;
}
.onoffswitch-inner:before {
    content: "有";
    padding-left: 0px;
    background-color: #FFFFFF; color: #666666;
}
.onoffswitch-inner:after {
    content: "沒有";
    padding-right: 10px;
    background-color: #FFFFFF; color: #666666;
    text-align: right;
}
.onoffswitch-switch {
    display: block; width: 24px; margin: 0.5px;
    background: #A1A1A1;
    position: absolute; top: 0; bottom: 0;
    right: 49px;
    border: 2px solid #E3E3E3; border-radius: 36px;
    transition: all 0.3s ease-in 0s; 
}
.onoffswitch-checkbox:checked + .onoffswitch-label .onoffswitch-inner {
    margin-left: 0;
}
.onoffswitch-checkbox:checked + .onoffswitch-label .onoffswitch-switch {
    right: 0px; 
    background-color: rgb(39, 202, 53); 
}

</style>



// WEBPACK FOOTER //
// src/components/Enow_Q.vue